import { render, staticRenderFns } from "./details.vue?vue&type=template&id=648f6024&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=648f6024&prod&lang=less&scoped=true"
import style1 from "./details.vue?vue&type=style&index=1&id=648f6024&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648f6024",
  null
  
)

export default component.exports